import React from "react"
import './PosterCard.scss'
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";

function PosterCard({ num, title, description, onClick, isupper = false, first = false }) {

    const renderPopover = (props) => (
        <Popover
            id="poster-popover"
            {...props}
            // Добавляем кастомный класс для полной стилизации в CSS
            className="custom-poster-popover"
        >
            <Popover.Body>
                Нажми на иконку, чтобы<br />открыть постер в новом окне
            </Popover.Body>
        </Popover>
    );

    return (
        <div className={`poster-card ${isupper && 'poster-card-upper'} ${first && 'poster-card-first'}`}>
            <div className={`poster-cover poster-image-${num}`}>
                <OverlayTrigger
                    trigger={['hover', 'focus']} 
                    placement="right"            
                    overlay={renderPopover}
                >
                <div className="poster-num-bg" onClick={onClick}>
                    <div className="poster-num-txt">
                        {`ПОСТЕР №${num}`}
                    </div>
                    <div className="circle">
                        <div className="poster-num-icon"></div>
                    </div>
                </div>
                </OverlayTrigger>
            </div>
            <div className="title">
                {title}
            </div>
            <div className="description">
                {description}
            </div>
            <div className="buttons-container">
                <a className="btn" href={`${window.location.origin}/posters/A3-${num}.pdf`} target="_blank" rel="noreferrer">
                    <div className="download-icon"></div>
                    <div className="btn-text">
                        {`скачать постер`}
                    </div>
                </a>
                <a className="btn" href={`${window.location.origin}/posters/Узнай_больше_Постер_${num}.pdf`} target="_blank" rel="noreferrer">
                    <div className="more-icon"></div>
                    <div className="btn-text">
                        {`узнать больше`}
                    </div>
                </a>
            </div>
        </div >
    );
}

export default PosterCard;